module.exports = __webpack_public_path__ + "static/microsoft_365_2-0a8949cab6a802fe5cb715f04cadbf0b.png";